import timelinemenu from "./timelinenav_template";
import { timelinelinks } from "./timelinenav_template";
import { setHighlightPage } from "src/components/highlight/highlight";
import { updateElementsHeightAndPosition,setCurrentAndPast } from "src/components/highlight/highlight_postrender";


export default (category) => {

    let cats = [];
    let catsdropdown = [];
    let cat1 = "-active";

    category.children.forEach(cat => {
        cats.push(timelinelinks(cat, cat1, "navigation__button"));
        catsdropdown.push(timelinelinks(cat, cat1, "tl-dropdown__link"));
        if (cat1 !== "")
            cat1 = "";
    });


    return timelinemenu(cats.join(""), catsdropdown.join(""));


}
const hashchangefunctions = () => {
    
    // console.log("on check")

    let hashoption = window.location.hash;

    if (hashoption) {
        // console.log("has hash", hashoption);
        document.querySelectorAll(".navigation__button-active,.tl-dropdown__link-active").forEach(item => {
            item.classList.remove("navigation__button-active")
            item.classList.remove("tl-dropdown__link-active")

        });
        const activepage = document.querySelectorAll("[href='" + hashoption + "']");
        let classprefix = "navigation__button"
        activepage.forEach(navpagebutton => {

            navpagebutton.classList.add(classprefix + "-active");
            if (classprefix === "navigation__button") {
                classprefix = "tl-dropdown__link";
            }

        });
        
        // import pageing from highlight
        // console.log("test");
        setHighlightPage();
        // setCurrentAndPast();
        // window.scroll({
        //   top: 0,
        //   left: 0
        // });
            
        // window.scrollTo(0,document.getElementById("timelinemenu").offsetTop);
        // console.log(document.getElementById("timelinemenu").getBoundingClientRect().top + document.documentElement.scrollTop);
        
        // window.scroll({
        //   top: document.getElementById("timelinemenu").getBoundingClientRect().top + document.documentElement.scrollTop-10,
        //   left: 0,
        //   behavior: 'smooth'
        // });
        window.scroll({
          top:0,//document.getElementById("timelinemenu").getBoundingClientRect().top + document.documentElement.scrollTop,
          left: 0,
          behavior: 'smooth'
        });
        // console.log(activepage, activepage.innerHTML);
        //  activepage.innerHTML;
    }
    document.getElementById("dropdownchoise").innerHTML = document.querySelector(".navigation__button-active").innerHTML;


}

const showOrHideDL = (showOrHide = "toggle") => {

    // console.log("test", showOrHide);
    let dl_list = document.getElementById("tl-dropdown__list");
    let dl_cevron = document.querySelector(".tl-dropdown__iconmore");

    const show = () => {

        dl_list.classList.remove("d-none");
        dl_cevron.innerHTML = "expand_less";
    }
    const hide = () => {

        dl_list.classList.add("d-none");
        dl_cevron.innerHTML = "expand_more";
    }

    if (showOrHide === "toggle") {
        if ([...dl_list.classList].includes("d-none")) {
            // console.log("removeing")
            show();
        }
        else {
            // console.log("adding");
            hide();
        }
    }
    else if (showOrHide === "show") {
        show();
    }
    else if (showOrHide === "hide") {
        hide();
    }
}

export const timelinenav_postrender = () => {


    // setAndAnalyseWidth();
    hashchangefunctions()
    window.addEventListener('hashchange', () => {
        hashchangefunctions();
    }, false);

    window.addEventListener('resize', () => {
        // console.log("resize")
        // setAndAnalyseWidth();
        if (window.innerWidth > 995) {

            showOrHideDL("hide");

        }
    }, false)

    document.querySelectorAll(".tl-dropdown__link").forEach(link => {
        link.addEventListener("click", () => {
            showOrHideDL("hide");
        }, false);
    })

    document.getElementById("tl-dropdown__button").addEventListener("click", () => {

        showOrHideDL("toggle");

    }, false);

}
